import React from 'react';
import './Board.scss';
import Webcam from 'react-webcam';
import Spin from './Spin';


const Board = ({  position, isSpinning, boardItems, coinImg, startSpinning, stopSpinning, stop}) => {

  const videoConstraints = {
    width: 400,
    height: 400,
    facingMode: "user",
  };

  return (
    <div className={`GameBoard ${isSpinning ? 'spinning' : ''}`}>
      <div className='cameraBody'>
          <Webcam
              className='camera'
              style={{ position: 'absolute', marginLeft: '-200px' }}
              muted
              videoConstraints={videoConstraints}
          />
          <Spin onSpin={startSpinning} onStop={stopSpinning} isSpinning={isSpinning} stop={stop} /> 
      </div>
      {boardItems.map((item, index) => (
        <div key={index} className={`BoardItem ${index === position ? 'active' : ''} ${item.type}`}>
          {item.type === "coin" ? 
            <div className='coins'>
              <img src={coinImg} alt='crab Icon'/>
              <div className='coin1'>{item.value}</div>
            </div>
            :
            <div className='whammy'>
              <img src={item.value} alt='crab Icon'/>
            </div>
          }
        </div>
      ))}
    </div>
  );
};

export default Board;